import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faCheck,
  faFileCheck,
  faSpinner,
  faXmark,
  faEnvelope,
  faCircleExclamation,
  faBan,
} from "@fortawesome/sharp-regular-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { AppealCurrentStatus } from "@/__generated__/graphql";
import { getAppealCurrentStatusLabel } from "shared/src/constants/appealCurrentStatus";
import styles from "./status-indicator.module.scss";

interface StatusIndicatorProps {
  currentStatus: string;
}

interface StatusDisplay {
  icon: IconDefinition;
  className: string;
}

const STATUS_DISPLAY: Record<string, StatusDisplay> = {
  [AppealCurrentStatus.Expired]: {
    icon: faXmark,
    className: styles.statusExpired,
  },
  [AppealCurrentStatus.ReferralInProgress]: {
    icon: faClock,
    className: styles.statusMuted,
  },
  [AppealCurrentStatus.Overturned]: {
    icon: faCheck,
    className: styles.statusSuccess,
  },
  [AppealCurrentStatus.Upheld]: {
    icon: faXmark,
    className: styles.statusError,
  },
  [AppealCurrentStatus.Submitted]: {
    icon: faCheck,
    className: styles.statusSubmitted,
  },
  [AppealCurrentStatus.InSupport]: {
    icon: faCircleExclamation,
    className: styles.statusWarning,
  },
  [AppealCurrentStatus.InProgress]: {
    icon: faClock,
    className: styles.statusInProgress,
  },
  [AppealCurrentStatus.LetterGenerating]: {
    icon: faSpinner,
    className: styles.statusInProgress,
  },
  [AppealCurrentStatus.LetterGenerated]: {
    icon: faFileCheck,
    className: styles.statusInProgress,
  },
  [AppealCurrentStatus.Closed]: { icon: faBan, className: styles.statusClosed },
  [AppealCurrentStatus.Referred]: {
    icon: faEnvelope,
    className: styles.statusReferred,
  },
};

const DEFAULT_DISPLAY: StatusDisplay = {
  icon: faEnvelope,
  className: styles.statusReferred,
};

export function StatusIndicator({ currentStatus }: StatusIndicatorProps) {
  const statusDisplay = STATUS_DISPLAY[currentStatus] ?? DEFAULT_DISPLAY;
  const label = getAppealCurrentStatusLabel(currentStatus);

  return (
    <div className={`${styles.statusIndicator} ${statusDisplay.className}`}>
      <FontAwesomeIcon icon={statusDisplay.icon} className={styles.icon} />
      <span className={styles.statusText}>{label}</span>
    </div>
  );
}
